import { combineReducers } from 'redux';
import walletReducer from './walletReducer';

const rootReducer = combineReducers({
  wallet: walletReducer,
  // add more reducers as needed
});

export default rootReducer;